import {css, type Theme} from '@emotion/react';
import {configureFonts, getFontThemeList} from '@nfq/next-fonts';
import {createConfig} from '@nfq/react-grid';

import {globalCss, shadows, themeColors} from './theme';

export const fontDefinitions = configureFonts({
    OnAir: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'bold',
            preload: true,
            src: '/fonts/OnAir-Bold.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: 'normal',
            preload: true,
            src: '/fonts/OnAir-Regular.woff2'
        }
    ]
});

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const {configType, globalCss: globalGridCss} = createConfig(breakpoints, {
    baseSpacing: 0.4,
    container: {
        xs: 1440,
        sm: 1440,
        md: 1440,
        lg: 1440,
        xl: 'fluid',
        xxl: 'fluid'
    },
    containerPadding: {
        xs: 28,
        sm: 28,
        md: 28,
        lg: 49,
        xl: 49,
        xxl: 49
    }
});

export const theme: Theme = {
    boxShadows: shadows,
    colors: themeColors,
    fonts: getFontThemeList(fontDefinitions)
};

export const globals = css`
    ${globalCss}

    ${globalGridCss}

    *,
    &::before,
    &::after {
        box-sizing: border-box;
    }

    * {
        -webkit-tap-highlight-color: transparent;
        margin: 0;
        padding: 0;
    }

    html {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        scroll-behavior: smooth !important;
    }

    html, body {
        min-height: 100%;
        position: relative;
    }

    :root {
        font-size: 10px;
        font-family: ${theme.fonts.OnAir};
        color: ${theme.colors.textPrimary};
    }

    body {
    }

    #__next {
        display: flex;
        flex: 1 2 auto;
        flex-direction: column;
        min-height: 100%;
    }
`;